import { pickThemeColor, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import { Button, ButtonProps } from 'antd';
import styled, { css } from 'styled-components';

const getStylesByType = (type: ButtonProps['type']) => {
  switch (type) {
    case 'primary':
      return css`
        background: ${pickThemeColor('ORANGE_PRIMARY')};
        color: ${pickThemeColor('WHITE')};

        &:hover {
          background: ${pickThemeColor('ORANGE_PRIMARY')};
        }
      `;
    case 'link':
      return css`
        color: ${pickThemeColor('WHITE')};
        background-color: ${pickThemeColor('WHITE_SMOKE')};

        &:hover {
          color: ${pickThemeColor('WHITE')};
          background-color: ${pickThemeColor('WHITE_SMOKE')};
        }
      `;
    case 'dashed':
    case 'text':
      return css`
        background: ${pickThemeColor('WHITE_SMOKE')};
        color: ${pickThemeColor('SILVER')};
      `;
    case 'default':
      return css`
        border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
        background: ${pickThemeColor('WHITE')};
        color: ${pickThemeColor('DARK_PURPLE')};

        &:hover {
          background: ${pickThemeColor('LIGHT_PURPLE')};
          color: ${pickThemeColor('WHITE')};
        }
      `;
    default:
      return css`
        border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
        color: ${pickThemeColor('BLACK_PRIMARY')};
      `;
  }
};

const getStylesBySize = (size: ButtonProps['size']) => {
  switch (size) {
    case 'small': {
      return css`
        height: 2rem;
      `;
    }
    case 'large':
      return css`
        height: 2.5rem;
      `;
    case 'middle':
      return css`
        height: 1.825rem;
      `;
    default:
      return css``;
  }
};

const getStylesByShape = (shape: ButtonProps['shape']) => {
  switch (shape) {
    case 'circle':
      return css`
        border-radius: 50%;
      `;
    case 'round':
      return css`
        border-radius: 99em;
      `;
    default:
      return css`
        border-radius: 0.25rem;
      `;
  }
};

export const StyledButton = styled(Button)`
  cursor: pointer;

  &.ant-btn.template-button {
    ${pickThemeFontStyles('14', '22', 'SEMI_NORMAL')};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    height: auto;
    padding: 0 1rem;

    & .anticon {
      ${pickThemeFontStyles('24', '24')};
      height: ${pickThemeFontSize('24')};
    }

    && {
      ${(props) => getStylesByShape(props.shape)}
      ${(props) => getStylesBySize(props.size)}
      ${(props) => getStylesByType(props.type)}
    }

    &&&&.ant-btn-dangerous {
      background: ${pickThemeColor('RED_CORAL')};
      color: ${pickThemeColor('WHITE')};
      border-color: ${pickThemeColor('RED_CORAL')};

      &:hover {
        background: ${pickThemeColor('RED_CORAL_HOVER')};
        color: ${pickThemeColor('WHITE')};
        border-color: ${pickThemeColor('RED_CORAL_HOVER')};
      }
    }

    &&&&.ant-btn-background-ghost {
      background-color: transparent;
      border-color: transparent;
      color: ${pickThemeColor('GREY')};

      &:hover {
        background-color: ${pickThemeColor('LIGHT_PURPLE')};
        color: ${pickThemeColor('WHITE')};
      }

      &.ant-btn-dangerous {
        color: ${pickThemeColor('RED_CORAL')};
        border: 1px solid transparent;

        &:hover {
          background-color: ${pickThemeColor('RED_CORAL_HOVER')};
          border-color: ${pickThemeColor('RED_CORAL_HOVER')};
          color: ${pickThemeColor('WHITE')};
        }
      }
    }
  }
`;
